module.exports = __webpack_public_path__ + "media/components/country-flag/static/gr-24d78920063fe4c06451040f10e2fd4b.svg";